import { createAction } from '@reduxjs/toolkit';

export const searchAssetsBySmartSearchIdSucceeded = createAction('ASSET/SEARCH_BY_SMART_SEARCH_ID/SUCCEEDED');
export const searchAssetsFailed = createAction('ASSET/SEARCH/FAILED');
export const searchAssetsLoading = createAction('ASSET/SEARCH/LOADING');
export const searchAssetsSucceeded = createAction('ASSET/SEARCH/SUCCEEDED');

export const setSelectedAssetsById = createAction('ASSET/SET/SELECTED');
export const toggleSelectedAsset = createAction('ASSET/TOGGLE/SELECTED');
